import { useWatch } from "react-hook-form";

/**
 * "120 / 250" counter shown inside the box of a form field that has a
 * character limit, at its right end (bottom-right corner for a textarea). It
 * reads the field's current value from the surrounding react-hook-form form,
 * so it follows the typing without the field having to pass anything in.
 * Turns red once the limit is reached.
 */
export function FieldCharacterCounter({
  fieldUid,
  limit,
}: {
  fieldUid: string;
  limit: number;
}) {
  const value = useWatch({ name: fieldUid });
  const used = String(value ?? "").length;

  /**
   * BEFORE - a line of its own above the label:
   *   <p className={`text-xs text-right mb-1 ${...}`}>
   * It now sits inside the box, so it keeps to one line and has no margin.
   */
  return (
    <span
      className={`text-xs whitespace-nowrap ${
        used >= limit ? "text-red-500 font-semibold" : "text-gray-500"
      }`}
    >
      {used} / {limit}
    </span>
  );
}
